import { useRef, useState, useEffect, useCallback } from "react";
import { ChatInput, ChatInputHandle } from "@mbassist/chat-surface";

import "./style.scss";
import { FirebaseAuthContainer } from "../../common/containers/auth/firebase-auth-container.util";
import { ToastContainer } from "../toast/toast.comp";
import { RecognitionButton, RecognitionMode } from "../recognition-button/recognition-button.comp";
import { isMobileDevice } from "../../common/utilities/platform/platform.util";

const Footer = ({ setNewMessage }: { setNewMessage?: (arg1: string) => void }) => {
    const defaultPlaceholder = "Ask MBAssist...";
    const { knowledgeBase } = FirebaseAuthContainer.useContainer();
    const { showToast } = ToastContainer.useContainer();
    const [isActive, setIsActive] = useState(false);
    const [question, setQuestion] = useState("");
    const [speechListening, setSpeechListening] = useState(false);
    const [speechTranscript, setSpeechTranscript] = useState("");
    const chatInputRef = useRef<ChatInputHandle>(null);

    useEffect(() => {
        if (!isMobileDevice()) chatInputRef.current?.focus();
    });

    useEffect(() => {
        setQuestion("");
        setIsActive(knowledgeBase?.status === "active");
    }, [knowledgeBase]);

    useEffect(() => {
        if (speechListening) {
            setQuestion(speechTranscript);
        }
    }, [speechListening, speechTranscript]);

    const placeholder = speechListening ? "I'm listening..." : defaultPlaceholder;

    const handleQuestion = useCallback(
        (recognizedQuestion: string) => {
            setQuestion("");
            if (setNewMessage && recognizedQuestion) {
                setNewMessage(recognizedQuestion);
            }
        },
        [setNewMessage]
    );

    const handleSend = () => {
        if (question) handleQuestion(question);
    };

    const handleErrorMessage = (message: string) => {
        showToast(message);
    };

    return (
        <div className={`footer${speechListening ? " footer-listening" : ""}`}>
            <div className="footer-text">
                <div className="footer-text-input">
                    <ChatInput
                        ref={chatInputRef}
                        value={question}
                        onChange={setQuestion}
                        onSend={handleSend}
                        placeholder={placeholder}
                        ariaLabel="Ask a question"
                        disabled={!isActive}
                        isListening={speechListening}
                        speechButton={
                            <RecognitionButton
                                size={136}
                                className="footer-mic"
                                onRecognized={handleQuestion}
                                setSpeechListening={setSpeechListening}
                                setSpeechTranscript={setSpeechTranscript}
                                handleErrorMessage={handleErrorMessage}
                                mode={RecognitionMode.COMBINED}
                                disabled={!isActive}
                            />
                        }
                    />
                </div>
            </div>
        </div>
    );
};

export default Footer;
